module.exports = "<app-single-image-upload-com [bucket]=\"bucket\" (event)=\"uploadChange($event)\" [original_key]=\"value\">\n</app-single-image-upload-com>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/form-controls/single-image/single-image.form-control.html
// module id = ./src/app/modules/shared/form-controls/single-image/single-image.form-control.html
// module chunks = main